import { CommonModule } from '@angular/common'
import { Component, Input, ViewChild } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { E11DynamicFormModule } from '@engineering11/ui-lib/e11-form-builder'
import { E11ShowHideWrapperComponent } from '@engineering11/ui-lib/e11-show-hide'
import { TranslateModule } from '@ngx-translate/core'
import { IApplicationAutoResponseFormData } from '../auto-response.model'
import { IAutomationFormConfig } from '../automation-form-message'
import { AutomationAutoResponseHelperComponent } from '../partials/automation-auto-response-helper.component'
import { AutomationFormHeaderComponent } from '../partials/automation-form-header.component'
import { AutomationMessageFormComponent } from '../partials/automation-message-form.component'
import { AutomationTypeDisplayNames } from '../partials/automation-upgrade-prompt.component'

@Component({
  selector: 'automation-auto-response-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    E11DynamicFormModule,
    TranslateModule,
    E11ShowHideWrapperComponent,
    AutomationFormHeaderComponent,
    AutomationAutoResponseHelperComponent,
    AutomationMessageFormComponent,
  ],
  template: `
    <div>
      <automation-form-header
        [sectionTitle]="'Application Auto Response'"
        [showEnableSwitch]="showEnableSwitch"
        [isCollapsed]="isCollapsed"
        [isEnabled]="isEnabled"
        (enabledChanged)="isEnabled = $event"
        (isCollapsedChanged)="isCollapsed = !isCollapsed"
      ></automation-form-header>

      <div class="e11-mb-2">
        <span class="e11-mr-1"> {{ 'Automatically send messages to candidates as they complete their application.' }}</span>
        <job-automation-auto-response-helper></job-automation-auto-response-helper>
      </div>
      <e11-show-hide-wrapper [isCollapsed]="isCollapsed">
        <automation-message-form
          #autoResponseFormRef
          [automationTypeDisplayName]="automationTypeDisplayName"
          [formFieldName]="'autoResponse'"
          [formConfig]="formConfig"
          [loading]="loading"
          [showEnableSwitch]="false"
          [showResetButton]="showResetButton"
          [formData]="_initialData"
          [footNoteMessageType]="'text'"
          [footNoteText]="'Sent to the candidates as their applications are submitted'"
        >
        </automation-message-form>
      </e11-show-hide-wrapper>
    </div>
  `,
})
export class AutomationAutoResponseFormComponent {
  @ViewChild('autoResponseFormRef') autoResponseFormRef!: AutomationMessageFormComponent

  @Input() loading = false
  @Input() showEnableSwitch = false
  @Input() showResetButton = false
  @Input() formConfig: IAutomationFormConfig | undefined
  @Input() set initialData(data: IApplicationAutoResponseFormData | undefined) {
    this._initialData = data
    this.isEnabled = data?.enabled ?? false
  }
  _initialData?: IApplicationAutoResponseFormData

  automationTypeDisplayName = AutomationTypeDisplayNames.ApplicationAutoResponse
  isCollapsed = false
  isEnabled = false

  get value(): IApplicationAutoResponseFormData {
    const formValue = this.autoResponseFormRef.value
    return {
      ...formValue,
      enabled: this.isEnabled,
    }
  }

  validate(): boolean {
    this.autoResponseFormRef.formRef?.onSubmitClick()
    return this.autoResponseFormRef.formRef?.form?.valid ?? false
  }
}
